export const generatePrompt = (formData: {
  topic: string; // What the text is about
  tone: string; // Tone of the text
  length: string; // Length of the text (e.g., short, medium, long)
  language: string; // Language of the output
}): string => {
  // Destructure the inputs from the form
  const { topic, tone, length, language } = formData;

  // Create a template for the OpenAI prompt


  const paraphraseTemplate = `
  
  Task: Write a unique and clear paraphrase of the following text.
   Maintain the structure of the original (e.g. body text remains body text) 
     The tone should be "${tone}". Avoid plagiarism completely and use synonyms that accurately reflect the context
      and meaning. The goal is for the rewritten text to be considered 
      a standalone new version and to convey the same information as the original in a new way.
       Direct quotations should remain the same.
---
Here is the original text:   "${topic}".
---
Write the output always and only in the output language.
Output language: ${language}
Output length: ${length}

`;

  // Return the dynamically generated prompt
  return paraphraseTemplate.trim();
};
